/* HubSpot form modal — opener/closer for snippets/hubspot-form-modal.liquid.
 *
 * - Opens a [data-hubspot-form-modal] <dialog> from any element with
 *   data-modal-open="{dialog id}", anywhere on the page.
 * - Closes on the close button, backdrop click, or Esc (native to <dialog>).
 * - Mirrors the newsletter/hubspot-embedded-form UX: hides each text field's label
 *   and surfaces its text as the input placeholder.
 *
 * Standalone (no Aerofoils dependency) and guarded so the snippet can be rendered
 * more than once on a page without double-binding.
 */
(function () {
  if (window.__hsFormModalInit) return;
  window.__hsFormModalInit = true;

  function loadHubSpotScript(body) {
    var scriptSrc = body && body.dataset ? body.dataset.hubspotScriptSrc || "" : "";
    var loaderKey = scriptSrc;

    if (body && body.dataset && body.dataset.hubspotTargetId) {
      loaderKey += ":" + body.dataset.hubspotTargetId;
    }

    if (!scriptSrc) {
      return Promise.reject(new Error("HubSpot script source is missing."));
    }

    if (window.Aerofoils && typeof window.Aerofoils.loadScriptOnce === "function") {
      return window.Aerofoils.loadScriptOnce({
        key: "hubspot-forms-runtime:" + loaderKey,
        src: scriptSrc,
        async: true,
        defer: true,
        dataset: {
          hubspotFormModalScript: "true",
        },
        test: function () {
          return !!body.querySelector(".hsfc-Form, .hs-form, form");
        },
      });
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      script.defer = true;
      script.dataset.hubspotFormModalScript = "true";
      script.addEventListener("load", resolve, { once: true });
      script.addEventListener("error", reject, { once: true });
      (document.head || document.body).appendChild(script);
    });
  }

  function cleanLabel(label) {
    var clone = label.cloneNode(true);

    clone.querySelectorAll('.hsfc-FieldLabel__RequiredIndicator, .hs-form-required').forEach(function (node) {
      node.remove();
    });

    return clone.textContent
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/[:：]\s*$/, '');
  }

  function findLabel(input, scope) {
    if (input.id) {
      var byFor = scope.querySelector('label[for="' + input.id + '"]');
      if (byFor) return byFor;
    }

    var field = input.closest(
      '.hsfc-TextField, .hsfc-EmailField, .hsfc-PhoneField, .hsfc-NumberField, .hsfc-Field, .hs-form-field, .field'
    );

    return field ? field.querySelector('.hsfc-FieldLabel, label') : null;
  }

  function placeLabelsInside(scope) {
    var selector =
      'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"]), textarea';

    Array.prototype.slice.call(scope.querySelectorAll(selector)).forEach(function (input) {
      if (
        input.closest(
          '.hsfc-CheckboxField, .hsfc-RadioField, .hsfc-DataPrivacyField, .hs-form-booleancheckbox, .legal-consent-container, .inputs-list'
        )
      ) {
        return;
      }

      if (input.dataset.hsLabelPlaced === 'true') return;

      var label = findLabel(input, scope);
      if (!label) return;

      var text = cleanLabel(label);

      if (text && !input.getAttribute('placeholder')) {
        input.setAttribute('placeholder', text);
      }

      label.classList.add('hubspot-embedded-form__visually-hidden');
      input.dataset.hsLabelPlaced = 'true';
    });
  }

  function createHubSpotForm(dialog, body) {
    var target = dialog.querySelector("[data-hubspot-form-modal-target]");
    var portalId = body.dataset.hubspotPortalId || "";
    var formId = body.dataset.hubspotFormId || "";
    var region = body.dataset.hubspotRegion || "";

    if (!target || !portalId || !formId) {
      dialog.dataset.hsFormModalError = "true";
      return Promise.resolve();
    }

    target.innerHTML = "";
    target.classList.add("hs-form-html");
    target.dataset.formId = formId;
    target.dataset.portalId = portalId;

    if (region) {
      target.dataset.region = region;
    } else {
      target.removeAttribute("data-region");
    }

    return Promise.resolve();
  }

  /* Prefill (hidden) fields from the JSON in data-hubspot-prefill on the modal
   * body: {"product_name": "…"}. Matches a field whose name equals the key or
   * ends with "/key" (HubSpot's new embed prefixes names, e.g. "0-1/product_name").
   * Values are written through the native setter and followed by input/change
   * events so HubSpot's React-based form picks them up. */
  function setNativeValue(field, value) {
    var proto =
      field instanceof window.HTMLTextAreaElement
        ? window.HTMLTextAreaElement.prototype
        : field instanceof window.HTMLSelectElement
          ? window.HTMLSelectElement.prototype
          : window.HTMLInputElement.prototype;
    var descriptor = Object.getOwnPropertyDescriptor(proto, "value");

    if (descriptor && typeof descriptor.set === "function") {
      descriptor.set.call(field, value);
    } else {
      field.value = value;
    }

    field.dispatchEvent(new Event("input", { bubbles: true }));
    field.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /* Product context for forms opened from a product section (inquiry, notify
   * me, …). Besides the native Shopify variant this includes the configurator
   * selection of eFoil sets, which is not represented by variants: taken from
   * section.aerofoilsBundleInquiryContext() when the bundle JS provides it,
   * otherwise from its hidden form inputs (legacy path). Keys match the
   * HubSpot hidden fields. */
  function readInputValue(scope, name) {
    var input = scope.querySelector('input[name="' + name + '"]');
    return input && input.value ? String(input.value) : "";
  }

  function getSelectedVariant(section) {
    var input = section.querySelector("[data-product-variant-id]");
    var script = section.querySelector("[data-product-variants]");

    if (!input || !script) return null;

    try {
      var variants = JSON.parse(script.textContent || "[]");
      var id = String(input.value || "");

      for (var i = 0; i < variants.length; i += 1) {
        if (String(variants[i].id) === id) return variants[i];
      }
    } catch (error) {
      /* ignore malformed JSON */
    }

    return null;
  }

  function buildProductContext(section) {
    if (!section) return {};

    var variant = getSelectedVariant(section);
    var variantTitle = "";

    if (variant && variant.options) {
      variantTitle = variant.options
        .filter(function (option) {
          return option && option !== "Default Title";
        })
        .join(" / ");
    }

    var configurationDisplay = readInputValue(section, "properties[_aerofoils_display]");
    var configurationJson = readInputValue(section, "properties[_aerofoils_config]");
    var legacySelection = readInputValue(section, "properties[_bundle_selection]");
    var titleNode = section.querySelector(".product-page-section__title");
    var priceNode = section.querySelector("[data-product-price]");
    var context = {
      product_name: titleNode ? titleNode.textContent.replace(/\s+/g, " ").trim() : "",
      product_variant: variantTitle,
      product_sku: variant && variant.sku ? String(variant.sku) : "",
      product_configuration: configurationDisplay || legacySelection,
      product_configuration_json: configurationJson,
      product_price: priceNode ? priceNode.textContent.replace(/\s+/g, " ").trim() : "",
      page_url: window.location.href,
    };

    /* eFoil sets: the bundle JS (section-product-board.js) exposes the full
     * configuration incl. add-ons and component SKUs, which replace the SKU
     * of the parent set variant. */
    if (typeof section.aerofoilsBundleInquiryContext === "function") {
      var bundleContext = section.aerofoilsBundleInquiryContext() || {};

      Object.keys(bundleContext).forEach(function (key) {
        if (bundleContext[key]) context[key] = bundleContext[key];
      });
    }

    Object.keys(context).forEach(function (key) {
      if (!context[key]) delete context[key];
    });

    return context;
  }

  function mergeProductContext(dialog, trigger) {
    var section = trigger ? trigger.closest("[data-product-page-section]") : null;
    var body = dialog.querySelector("[data-hubspot-form-modal-body]");

    if (!section || !body) return;

    var prefill = {};

    try {
      prefill = JSON.parse(body.dataset.hubspotPrefill || "{}") || {};
    } catch (error) {
      prefill = {};
    }

    var context = buildProductContext(section);

    Object.keys(context).forEach(function (key) {
      prefill[key] = context[key];
    });

    body.dataset.hubspotPrefill = JSON.stringify(prefill);
  }

  function applyPrefill(dialog) {
    var body = dialog.querySelector("[data-hubspot-form-modal-body]");

    if (!body || !body.dataset.hubspotPrefill) return;

    var form = body.querySelector("form");

    if (!form) return;

    var data;

    try {
      data = JSON.parse(body.dataset.hubspotPrefill);
    } catch (error) {
      return;
    }

    if (!data || typeof data !== "object") return;

    var fields = Array.prototype.slice.call(
      form.querySelectorAll("input, textarea, select")
    );

    Object.keys(data).forEach(function (key) {
      var value = data[key];

      if (value == null) return;

      fields.forEach(function (field) {
        var name = field.getAttribute("name") || "";
        var baseName = name.split("/").pop();

        if (name !== key && baseName !== key) return;
        if (field.type === "checkbox" || field.type === "radio") return;
        if (String(field.value) === String(value)) return;

        setNativeValue(field, String(value));
      });
    });
  }

  function observeBody(dialog, body) {
    var observer;

    if (!body) return;

    if (dialog.hsFormModalObserver) {
      dialog.hsFormModalObserver.disconnect();
    }

    placeLabelsInside(body);

    observer = new MutationObserver(function () {
      placeLabelsInside(body);

      if (body.querySelector(".hsfc-Form, .hs-form, form")) {
        dialog.dataset.hsFormModalRendered = "true";
        dialog.dataset.hsFormModalError = "false";
        applyPrefill(dialog);
      }
    });

    observer.observe(body, { childList: true, subtree: true });
    dialog.hsFormModalObserver = observer;

    if (body.querySelector(".hsfc-Form, .hs-form, form")) {
      dialog.dataset.hsFormModalRendered = "true";
      dialog.dataset.hsFormModalError = "false";
    }
  }

  function renderDialog(dialog) {
    var body = dialog.querySelector("[data-hubspot-form-modal-body]");

    if (
      !body ||
      dialog.dataset.hsFormModalRequested === "true" ||
      dialog.dataset.hsFormModalRendered === "true"
    ) {
      return Promise.resolve();
    }

    dialog.dataset.hsFormModalRequested = "true";
    observeBody(dialog, body);
    createHubSpotForm(dialog, body);

    return loadHubSpotScript(body)
      .catch(function () {
        dialog.dataset.hsFormModalRequested = "false";
        dialog.dataset.hsFormModalError = "true";
      });
  }

  function initModal(dialog) {
    if (!dialog || dialog.dataset.hsFormModalReady === 'true') return;
    dialog.dataset.hsFormModalReady = 'true';

    Array.prototype.slice
      .call(dialog.querySelectorAll('[data-hs-form-modal-close]'))
      .forEach(function (button) {
        button.addEventListener('click', function () {
          closeDialog(dialog);
        });
      });

    // Backdrop click (the dialog element itself, outside the panel).
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        closeDialog(dialog);
      }
    });
  }

  function openDialog(dialog) {
    if (!dialog || dialog.open) return;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', 'open');
    }
  }

  function closeDialog(dialog) {
    if (!dialog) return;

    if (dialog.open && typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  // Delegated opener: any [data-modal-open] whose target is one of our dialogs.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-modal-open]');
    if (!trigger) return;

    var targetId = trigger.getAttribute('data-modal-open');
    if (!targetId) return;

    var dialog = document.getElementById(targetId);
    if (!dialog || !dialog.hasAttribute('data-hubspot-form-modal')) return;

    event.preventDefault();
    initModal(dialog);
    // Product context (variant, SKU, configurator selection, price, URL) is
    // refreshed on every open so it reflects the current selection.
    mergeProductContext(dialog, trigger);
    renderDialog(dialog);
    openDialog(dialog);
    // Re-apply on every open so runtime updates of data-hubspot-prefill
    // reach an already rendered form.
    applyPrefill(dialog);
  });

  window.AerofoilsHubspotFormModal = window.AerofoilsHubspotFormModal || {};
  window.AerofoilsHubspotFormModal.applyPrefill = applyPrefill;
  window.AerofoilsHubspotFormModal.buildProductContext = buildProductContext;

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-hubspot-form-modal]')
      .forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var dialogs = event.target.matches && event.target.matches("[data-hubspot-form-modal]")
      ? [event.target]
      : Array.prototype.slice.call(
          event.target.querySelectorAll("[data-hubspot-form-modal]")
        );

    dialogs.forEach(function (dialog) {
      if (dialog.hsFormModalObserver) {
        dialog.hsFormModalObserver.disconnect();
        dialog.hsFormModalObserver = null;
      }
    });
  });
})();
